export const cacheKeys = {
  LOCALMACHINE_INFO: 'LOCALMACHINE_INFO',
  REGISTER_TOKEN: 'REGISTER_TOKEN',
  IS_VT_ENABLE: 'IS_VT_ENABLE',
  USER_TOKEN: 'USER_TOKEN',
  USER_INFO: 'USER_INFO',
  X_LESYNC_TOKEN: 'X-Lesync-Token',
  START_INFO: 'START_INFO',
  LOG_PARAM1: 'LOG_PARAM1',
  INSTALL_PARAM: 'INSTALL_PARAM',
  ENABLE_QUICK_INSTALL: 'ENABLE_QUICK_INSTALL',
  RELEASE_NOTES_VERSION: 'RELEASE_NOTES_VERSION',
  USER_SCORE_VISIBLE: 'USER_SCORE_VISIBLE',
  SHOW_CLEAN_TO_DSTORE_TIME: 'SHOW_CLEAN_TO_DSTORE_TIME',
};

// 用于记录滚动页面位置
export const SCROLL_PAGE = 'SCROLL_PAGE';

// 判断网络
export const localKeys = {
  LAST_PIN_CHECK_TIME: 'LAST_PIN_CHECK_TIME',
  SHOW_PIN_NO_MORE: 'SHOW_PIN_NO_MORE',
};

// 分类存储
export const categoryKeys = {
  A_CODE_CLASS_TAG: 'A_CODE_CLASS_TAG',
  CODE_CLASS_TAG: 'CODE_CLASS_TAG',
};

// 我的软件小红点
export const mySoftKeys = {
  RED_SPOT_SOFT: 'RED_SPOT_SOFT',
};

// 我的软件小红点
export const myWallpaper = {
  WP_RED_COLLECCT: 'WP_RED_COLLECCT',
};

// 教育频道
export const education = {
  EDUSTAGE: 'EDUSTAGE', // 学龄阶段
  EDU_DETAIL_INFO: 'EDU_DETAIL_INFO', // 用于记录视频详情中视频播放进度信息
};

// 欢迎页上次弹出时间 YYYYMMDD
export const welcomePopTime = 'WELCOMEPOPTIME';

// 加速器下次弹出时间
export const fasterProductNextTime = 'FASTER_PRODUCT_NEXT_TIME';
// 今天是否点击下载过应用
export const todayDownloadApp = 'TODAY_DOWNLOAD_APP';
// 记录当前菜单的顺序
export const Menu_Record = 'MENU_RECORD';
// 记录当前菜单的顺序
export const Local_Theme = 'Local_Theme';

// 记录详情页面tab的位置
export const detailTab = 'DETAILTAB';

// 系统模式参数
export const BIZ_PARAM = 'BIZ_PARAM';
// 系统模式
export const GUI_MODE_INFO = 'GUI_MODE_INFO';
// 用改中心上次请求时间
export const SURVEY_USER_UPDATE_TIME = 'SURVEY_USER_UPDATE_TIME';
//是否弹出过壁纸下载路径弹窗
export const WP_DOWNLOAD = 'WP_DOWNLOAD';
